/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindFileQueryResponse2 } from './FindFileQueryResponse2';
import {
    FindFileQueryResponse2FromJSON,
    FindFileQueryResponse2FromJSONTyped,
    FindFileQueryResponse2ToJSON,
} from './FindFileQueryResponse2';

/**
 * 
 * @export
 * @interface ComplaintRecordQueryResponse
 */
export interface ComplaintRecordQueryResponse {
    /**
     * 
     * @type {string}
     * @memberof ComplaintRecordQueryResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ComplaintRecordQueryResponse
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof ComplaintRecordQueryResponse
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ComplaintRecordQueryResponse
     */
    employeeName?: string | null;
    /**
     * 
     * @type {Array<FindFileQueryResponse2>}
     * @memberof ComplaintRecordQueryResponse
     */
    files?: Array<FindFileQueryResponse2>;
}

/**
 * Check if a given object implements the ComplaintRecordQueryResponse interface.
 */
export function instanceOfComplaintRecordQueryResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ComplaintRecordQueryResponseFromJSON(json: any): ComplaintRecordQueryResponse {
    return ComplaintRecordQueryResponseFromJSONTyped(json, false);
}

export function ComplaintRecordQueryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComplaintRecordQueryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'message': !exists(json, 'message') ? undefined : json['message'],
        'createdAt': !exists(json, 'createdAt') ? undefined : json['createdAt'],
        'employeeName': !exists(json, 'employeeName') ? undefined : json['employeeName'],
        'files': !exists(json, 'files') ? undefined : ((json['files'] as Array<any>).map(FindFileQueryResponse2FromJSON)),
    };
}

export function ComplaintRecordQueryResponseToJSON(value?: ComplaintRecordQueryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'message': value.message,
        'createdAt': value.createdAt,
        'employeeName': value.employeeName,
        'files': value.files === undefined ? undefined : ((value.files as Array<any>).map(FindFileQueryResponse2ToJSON)),
    };
}

